import clsx from 'clsx';
import { displayMonetaryAmount } from '../../../util';
import { MonetaryAmount } from '../../../generated/graphql';
import { Icon } from '../Icon';
import { motion } from 'framer-motion';
import { useHover } from 'react-use';

export interface MonetaryAmountWidgetProps {
  title?: string;
  className?: string;
  isLoading?: boolean;
  suffix?: string;
  monetaryAmount: MonetaryAmount | undefined | null;
  onClick?: () => void;
  withChevron?: boolean;
}

export function MonetaryAmountWidget({
  title,
  isLoading,
  suffix,
  className,
  monetaryAmount,
  onClick,
  withChevron,
}: MonetaryAmountWidgetProps) {
  if (isLoading) return <></>;

  const [hoverable] = useHover((hovered) => (
    <div
      onClick={onClick}
      className={clsx(
        'flex flex-col space-y-1',
        'rounded-[16px] pt-5 pl-5 pb-6 pr-[14px] shadow-mobileTile bg-darkMode-gray-mobileTile hover:bg-palette-600/20',
        'web:bg-[#212326] web:rounded-[20px] web:pb-[19.95px] web:pt-[18.6px] web:px-[24.8px] web:overflow-hidden',
        className
      )}
    >
      {title && (
        <div className="flex flex-row justify-between h-[25px]">
          <div
            className={clsx(
              'whitespace-nowrap leading-[normal]',
              'text-darkMode-gray-medium text-[14px] font-extrabold tracking-[-0.154px] h-[17px] uppercase',
              'web:text-darkMode-gray-light web:text-[22.6px] web:font-medium web:tracking-[-0.531px] web:mb-0 web:h-[27px]'
            )}
          >
            {title}
          </div>
          {withChevron && (
            <motion.div className="ml-2 self-center" animate={hovered ? { x: 2 } : { x: 0 }}>
              <Icon icon={'chevronRight'} className={'text-palette-600'} />
            </motion.div>
          )}
        </div>
      )}
      <p
        className={clsx(
          'text-[28px] tracking-[-0.5px] leading-none truncate',
          'web:text-[46.5px] web:tracking-[-0.996px] web:leading-[normal] web:overflow-hidden web:text-ellipsis'
        )}
      >
        <span className={clsx('text-darkMode-gray-light', 'font-bold', 'web:font-medium')}>$</span>
        <span className={clsx('text-white', 'font-extrabold', 'web:font-bold')}>
          {displayMonetaryAmount(monetaryAmount, {
            nullishIsDash: true,
            withoutDollarSign: true,
          })}
        </span>
        {suffix && monetaryAmount && <span className={clsx('text-darkMode-gray-light font-semibold')}>{suffix}</span>}
      </p>
    </div>
    )
  );
  return hoverable;
}
